import React, { Fragment, useState } from "react";
import { compose } from "redux";
import classNames from "classnames";

import setResizing from "fantastic/actions/setResizing";
import actions from "fantastic/actions";
import connectActions from "fantastic/lib/connectActions";
import setSelected from "fantastic/actions/setSelected";
import setHovered from "fantastic/actions/setHovered";

import styles from "fantastic/components/hoc/styles";

import EditorColumn from "../Column";
import PreviewColumn from "../../preview/Column";
import ColumnResizer from "fantastic/components/common/ColumnResizer";
import Cell from "./table/Cell";

const Table = ({
  id,
  style,
  rows,
  preview,
  update,
  setSelected,
  setItemResizing,
  meta: { selected }
}) => {
  const [resizing, setResizing] = useState(null);
  const [currentResize, setCurrentResize] = useState(null);
  const [rowIndex, setRowIndex] = useState(null);

  const columnStyle = column => {
    return {
      width: column.width + "%"
    };
  };

  const tableStyle = {
    ...style,
    width: "100%"
  };

  const Column = preview ? PreviewColumn : EditorColumn;

  const handleResizeStart = (column, rIndex) => {
    setResizing(column);
    setItemResizing(id, true);
    setRowIndex(rIndex);
  };

  const handleResize = (index, prev, next) => {
    setCurrentResize([prev, next]);
  };

  const handleResizeStop = (index, values) => {
    setItemResizing(id, false);
    setResizing(null);
    update(id, index, values[0], values[1]);
  };

  const renderColumn = (column, index) => {
    const tdClasses = classNames("fantastic-table__column", {
      "fantastic-table__column--resizing": resizing && column.id === resizing.id
    });

    if (preview)
      return (
        <Cell
          key={index}
          style={columnStyle(column)}
          {...column}
          className={tdClasses}
        >
          <Column {...column} />
        </Cell>
      );

    return (
      <Fragment key={index}>
        <Cell
          {...column}
          className={tdClasses}
          style={
            column.meta.lastchild ? { width: "auto" } : columnStyle(column)
          }
        >
          <Column {...column} />
          {selected && (
            <a
              onClick={e => {
                e.stopPropagation();
                setSelected(column.id);
              }}
              className="btn btn-default fantastic-table__cell--selector"
            >
              <i className="fa fa-gear" />
            </a>
          )}
        </Cell>
        {selected && !column.meta.lastChild && (
          <ColumnResizer
            className="fantastic-table__resizer"
            onResizeStart={rIndex => handleResizeStart(column, rIndex)}
            onResizeStop={() => handleResizeStop(index, currentResize)}
            onResize={(prev, next) => handleResize(index, prev, next)}
          />
        )}
      </Fragment>
    );
  };

  const renderRow = (row, index) => {
    const trClasses = classNames({
      "fantastic-table__row--resizing": resizing && index === rowIndex
    });
    return (
      <tr key={index} className={trClasses}>
        {row.columns && row.columns.map(renderColumn)}
      </tr>
    );
  };

  return (
    <table style={tableStyle}>
      <tbody>{rows && rows.map(renderRow)}</tbody>
    </table>
  );
};

export default compose(
  styles("background"),
  connectActions({
    update: actions.updateTableColumns,
    setSelected,
    setItemResizing: setResizing
  })
)(Table);
